<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
	<polygon points="12,4 12,0 0,0 0,12 4,12 4,16 16,16 16,4" />
</svg>
</template>